import { FormControlLabel, Switch } from "@material-ui/core";
import React, { FC, useCallback } from "react";

export interface IRadioButtonProps {
  label: string;
  value: boolean;
  isDisabled: boolean;
  onChange: (val: boolean) => void;
}

const RadioButton: FC<IRadioButtonProps> = ({
  label,
  value,
  isDisabled,
  onChange
}) => {
  const handleChange = useCallback(
    event => {
      onChange(event.target.checked);
    },
    [onChange]
  );

  return (
    <FormControlLabel
      control={
        <Switch
          color="primary"
          checked={value}
          disabled={isDisabled}
          onChange={handleChange}
        />
      }
      label={label}
      labelPlacement="end"
    />
  );
};

export default RadioButton;
